module.exports = __webpack_public_path__ + "057d25fdad8acc54e4116d7704f40085.pdf";